import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'
import gradients from './gradients'
import container from './container'
import * as colors from 'colors'

import basic from './animations/basic-animation'

export const animations = [
  basic
]

export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , dimensions = chart.datum().dimensions
    , config = chart.datum().axes.infographic
    , grid = chart.layout.getGrid(dimensions, 1)
    , defs = d3.select(chart.node().ownerSVGElement).selectAll('defs')
    , serieColors = new Set
    , sliceGenerator = shape.pie()
                            .value(d => 1) // Equal values
                            .sort(null) // Maintain incoming serie order

  let cycles = grid.blocks.map(block => {
    // Draw a pie for every item in the range
    let points = seriesData.map((serie, idx) => {
      let point = util.getPoint(block.range.id, serie)
      serieColors.add(point.color)
      return Object.assign({}, point, { idx })
    })

    return {
      title: block.range.title,
      dimensions: block.dimensions,
      subtitle: block.range.subtitle,
      rangeId: block.range.id,
      block: block,
      slices: sliceGenerator(points)
    }
  })

  defs.call(gradients, Array.from(serieColors), chart.defaultTransition)
      .selectAll('linearGradient')
      .each(function (color) {
        d3.select(this)
          .selectAll('stop')
          .attr('stop-color', (d, idx) => {
            switch (idx) {
              case 0:
                return colors.adjustLightness(colors.lookup(color), 40)
              case 1:
              case 2:
                return colors.adjustLightness(colors.lookup(color), 5)
              case 3:
                return colors.adjustLightness(colors.lookup(color), -15)
            }
          })
     })

  selection.call(container, chart, cycles, grid, config)
}
